import { retrieveErrorFromApi } from '../../../helper'
import { setAppErrors } from '../../action/system'
import { PER_LOAD } from '../constants'
import fetchProducts from '../../axios/product'
import { appendCartProductMustToppings, appendCartProductProducts, appendCartProductToppings, setCartProductEnableQuantity, setCartProductItemFocus, setCartProductLoading, setCartProductMustToppings, setCartProductMustToppingsTotal, setCartProductProductFocus, setCartProductProducts, setCartProductProductsTotal, setCartProductToppingGroups, setCartProductToppings, setCartProductToppingsTotal } from '../../action/cartProduct'
import fetchProduct from '../../axios/product/get'
import fetchAllAdditivesGroups from '../../axios/additivesGroups/getAll'
import { batch } from 'react-redux'
import getExpertCartSetting from '../../axios/registration/expertCartSettings/get'
import { compareFilter } from './helper'

export const getCartProductsThunk = ({
	page = 0, size = PER_LOAD, nrTitle,
	productType, categoryId,
	businessScope,
	menuPositionId,
	activeForCashRegister,
	activeForShop,
}) => (dispatch, getState) => {
	dispatch(setCartProductLoading(true))
	return fetchProducts({
		page, size, nrTitle,
		productType, categoryId,
		activePosPrices: true,
		enabledForMenu: false,
		businessScope,
		menuPositionId,
		activeForCashRegister,
		activeForShop,
	}).then((res) => {
		const prevCategoryId = getState().cartCategory.categoryId
		const prevNrTitle = getState().cartProduct.searchText
		const isInitialLoad = getState().cartProduct.productsTotal === null
		if (isInitialLoad || compareFilter(categoryId, prevCategoryId, nrTitle, prevNrTitle)) {
			batch(() => {
				dispatch(setCartProductProductsTotal(parseInt(res.headers['x-products-total'])))
				if (page > 0 && size > 0) {
					dispatch(appendCartProductProducts(res.data))
				} else {
					dispatch(setCartProductProducts(res.data))
				}
				dispatch(setCartProductLoading(false))
			})
		} else {
			dispatch(setCartProductLoading(false))
		}
	}).catch((error) => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getCartSettingsThunk = (module, orderType) => dispatch => {
	return getExpertCartSetting(module, orderType)
		.then((res) => {
			dispatch(setCartProductEnableQuantity(res.data.showProductQuantity))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getCartMustToppingsThunk = ({ page = 0, size = PER_LOAD, categoryId, businessScope, activeForCashRegister, activeForShop }) => dispatch => {
	return fetchProducts({
		page, size,
		productType: 'TOPPING',
		categoryId,
		mustExtras: true,
		activePosPrices: true,
		hasAdditivesGroup: false,
		enabledForMenu: false,
		businessScope,
		activeForCashRegister,
		activeForShop,
	}).then((res) => {
		if (res && res.data) {
			if (res.headers['x-products-total']) {
				//check size & page make sure we are retrieving all products
				dispatch(setCartProductMustToppingsTotal(parseInt(res.headers['x-products-total'])))
			}
			if (page > 0 && size > 0) {
				//make sure we're querying pagination
				dispatch(appendCartProductMustToppings(res.data))
				return
			}

			dispatch(setCartProductMustToppings(res.data))
		}
	}).catch((error) => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getCartToppingsThunk = ({ page = 0, size = PER_LOAD, categoryId, businessScope, activeForCashRegister, activeForShop }) => dispatch => {
	return fetchProducts({
		page, size,
		productType: 'TOPPING',
		categoryId,
		mustExtras: false,
		activePosPrices: true,
		hasAdditivesGroup: false,
		enabledForMenu: false,
		businessScope,
		activeForCashRegister,
		activeForShop,
	}).then((res) => {
		if (res && res.data) {
			if (res.headers['x-products-total']) {
				//check size & page make sure we are retrieving all products
				dispatch(setCartProductToppingsTotal(parseInt(res.headers['x-products-total'])))
			}
			if (page > 0 && size > 0) {
				//make sure we're querying pagination
				dispatch(appendCartProductToppings(res.data))
				return
			}

			dispatch(setCartProductToppings(res.data))
		}
	}).catch((error) => {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const getCartProductThunk = (item) => dispatch => {
	return fetchProduct(item.itemId)
		.then((res) => {
			dispatch(setCartProductProductFocus(res.data))
			dispatch(setCartProductItemFocus(item))
		}).catch((error) => {
			// dispatch(setAppErrors(retrieveErrorFromApi(error))) todo
		})
}

export const getCartToppingGroupsThunk = (categoryId, relatedProductId, businessScope) => dispatch => {
	return fetchAllAdditivesGroups(0, 20, categoryId, true, true, relatedProductId, businessScope)
		.then((res) => {
			dispatch(setCartProductToppingGroups(res.data))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
